const PREFIX = 'FORUM'

export const DIRECTORY_GET_STATUS = `${PREFIX}_LOADING_STATUS`
export const DIRECTORY_GET_ERROR = `${PREFIX}_GET_ERROR`
export const DIRECTORIES_CLEAR = `${PREFIX}_DIRECTORIES_CLEAR`
export const DIRECTORY_GET = `${PREFIX}_GET`
export const DIRECTORIES_GET = `${PREFIX}S_GET`
export const DIRECTORY_CLEAR = `${PREFIX}_CLEAR`
export const GET_SUB_DIRECTORIES = `${PREFIX}_GET_SUB_DIRECTORIES`
